// =============================================================================
// Brand selection. (§2.1)
//
// ONE repo, ONE branch, TWO deployments. The brand is chosen at BUILD TIME by
// the VITE_BRAND environment variable, so a fix pushed to main rebuilds both
// schools — there is no second repo to keep in step.
//
//   npm run dev                     → Heguru (the default)
//   VITE_BRAND=happee npm run dev   → Happee
//
// On Cloudflare Pages each project sets VITE_BRAND in its own environment
// variables. Vite inlines it at build time, so changing it needs a redeploy.
//
// This file names no school. Each brand lives in ./brands/, and that is the
// entire white-label surface in the frontend — everything downstream is
// derived, not repeated:
//   - the theme palette          → src/lib/theme.js
//   - the PWA manifest and icons → vite.config.js, scripts/generate-icons.mjs
//   - the <title>, favicon and theme-color meta
//
// If you ever need a school-specific value somewhere a brand file cannot reach,
// mark it `// SCHOOL-SPECIFIC` so one grep finds every instance.
// =============================================================================

import { heguru } from './brands/heguru.js';
import { happee } from './brands/happee.js';

const BRANDS = { heguru, happee };

// Read from process.env under Node (vite.config.js, the scripts/) and from the
// inlined import.meta.env in the browser bundle. Neither exists in both places,
// hence the guards.
const requested =
  (typeof process !== 'undefined' && process.env && process.env.VITE_BRAND) ||
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_BRAND) ||
  'heguru';

// Fail loudly rather than falling back. A typo in the Cloudflare environment
// must not quietly ship one school's name and colours to the other's domain.
if (!BRANDS[requested]) {
  throw new Error(
    `Unknown VITE_BRAND "${requested}". Expected one of: ${Object.keys(BRANDS).join(', ')}`);
}

export const SCHOOL = BRANDS[requested];

// -----------------------------------------------------------------------------
// Money. MMK has no minor unit in practice, so no decimals.
// -----------------------------------------------------------------------------
export function money(amount) {
  const n = Number(amount || 0);
  return `${n.toLocaleString('en-US', { maximumFractionDigits: 0 })} ${SCHOOL.currency}`;
}

export const fullAppName = () => `${SCHOOL.name} ${SCHOOL.appName}`;
